import { BaseLayout } from "layouts/common/BaseLayout";
import { MprcLayoutInside } from "layouts/common/inside/MprcLayoutInside";
import * as React from "react";
import { Outlet } from "react-router";

////////////////////////////////////////////////////////////////////////////////////////////////////////

export const WelcomeLayout: React.FC = () => {
    return (
        <BaseLayout>
            <MprcLayoutInside
                lateralMenuComponent={null}
                subHeaderComponent={null}
                subHeaderAlwaysVisible={false}
                menuOpened={false}
            >
                <Outlet />
            </MprcLayoutInside>
        </BaseLayout>
    );
};
